import { Link } from 'react-router-dom';
import { DecoratedClient } from '@/db/types/client';

function timeAgo(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.floor(months / 12);
  return `${years} year${years === 1 ? '' : 's'} ago`;
}

interface RecentlyViewedClientsProps {
  clients: DecoratedClient[] | undefined;
}

function LoadingList() {
  return <div className="py-8 text-center text-gray-500">Loading...</div>;
}

function EmptyList() {
  return <div className="py-8 text-center text-gray-500">No recently viewed clients</div>;
}

function ClientList({ clients }: { clients: DecoratedClient[] }) {
  if (clients.length === 0) return <EmptyList />;

  return <>{clients.map(client => (
    <Link
      key={client.id}
      to={`/clients/${client.label}`}
      state={{ from: '/' }}
      className="flex items-center justify-between px-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors"
    >
      <span className="text-sm text-gray-900">{client.person.displayName}</span>
      <span className="text-xs text-gray-500 whitespace-nowrap">
        {client.last_viewed_at ? timeAgo(new Date(client.last_viewed_at)) : ''}
      </span>
    </Link>
  ))}</>;
}

export default function RecentlyViewedClients({ clients }: RecentlyViewedClientsProps) {
  return (
    <div className="flex flex-col min-h-0 flex-1">
      <h2 className="text-lg font-semibold text-gray-900 mb-3">Recently Viewed Clients</h2>
      <div className="bg-white rounded-lg border border-gray-200 flex-1 min-h-0 overflow-y-auto shadow-sm">
        {clients === undefined ? <LoadingList /> : <ClientList clients={clients} />}
      </div>
    </div>
  );
}
